var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-pagewrapper"},[(_vm.$store.state.userInfo.ready && this.$route.path !='/')?_c('van-empty',{attrs:{"image":"error","description":"该页面不存在,请点击此处返回首页"},nativeOn:{"click":function($event){return _vm.gotoIndex.apply(null, arguments)}}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }